import { Controller } from "@hotwired/stimulus"

// Disables every submit control associated with this form once it's submitted, but only
// swaps the text on the one actually clicked. Plain data-disable-with can't do this — it
// disables/relabels every control tied to the form uniformly, regardless of which one was
// clicked, which reads as multiple buttons "submitting" at once when a form has more than
// one submit control (e.g. two buttons outside the form, linked to it via form=).
//
// Reads event.submitter to find the clicked control. Disabling it must be deferred with
// setTimeout — disabling a submit control synchronously inside its own form's submit handler
// can cause the browser to exclude that control's name/value from what's actually sent, since
// the disabled check runs against live DOM state during serialization, which happens right
// after this handler returns. Deferring to the next tick lets the browser capture the
// submission first (same fix already used elsewhere in this app, see quote_groups.js).
export default class extends Controller {
  handleSubmit(event) {
    const submitter = event.submitter
    const buttons = document.querySelectorAll(`[form="${this.element.id}"]`)

    buttons.forEach((button) => {
      if (button === submitter) {
        button.textContent = "Submitting..."
      }
    })

    setTimeout(() => {
      buttons.forEach((button) => { button.disabled = true })
    }, 0)
  }
}
